import { render, staticRenderFns } from "./LayoutUser.vue?vue&type=template&id=8ce3f3a8&scoped=true&"
import script from "./LayoutUser.vue?vue&type=script&lang=js&"
export * from "./LayoutUser.vue?vue&type=script&lang=js&"
import style0 from "./LayoutUser.vue?vue&type=style&index=0&id=8ce3f3a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce3f3a8",
  null
  
)

export default component.exports